import { createFileRoute } from "@tanstack/react-router";
import MedicareTmsCoverage from "@/pages/MedicareTmsCoverage";
import {
  SITE_URL,
  buildBreadcrumbList,
  buildMedicalWebPage,
} from "@/components/schemaConstants";

const PAGE_URL = `${SITE_URL}/medicare-tms-coverage`;
const BREADCRUMB_ID = `${PAGE_URL}#breadcrumb`;

export const Route = createFileRoute("/medicare-tms-coverage")({
  head: () => ({
    meta: [
      {
        title:
          "Does Medicare Cover TMS for Depression? | Coral Springs, FL | Neuro Wellness",
      },
      {
        name: "description",
        content:
          "Yes, Medicare can cover TMS therapy for depression when criteria are met. Neuro Wellness is in-network with Medicare and verifies your benefits free.",
      },
      {
        property: "og:title",
        content: "Does Medicare Cover TMS for Depression? | Neuro Wellness",
      },
      {
        property: "og:description",
        content:
          "Medicare can cover TMS for depression when criteria are met. In-network Medicare provider in Coral Springs, FL. Free benefits check.",
      },
      { property: "og:url", content: PAGE_URL },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: PAGE_URL }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify(
          buildMedicalWebPage({
            name: "Does Medicare Cover TMS Therapy for Depression?",
            description:
              "Medicare Part B can cover TMS therapy for major depression when criteria are met. Neuro Wellness is an in-network Medicare provider in Coral Springs, FL.",
            url: PAGE_URL,
            id: `${PAGE_URL}#webpage`,
            breadcrumbId: BREADCRUMB_ID,
          }),
        ),
      },
      {
        type: "application/ld+json",
        children: JSON.stringify(
          buildBreadcrumbList(
            [
              { name: "Home", href: "/" },
              {
                name: "Insurance",
                href: "/insurance-for-tms-depression-treatment",
              },
              { name: "Medicare & TMS", href: "/medicare-tms-coverage" },
            ],
            BREADCRUMB_ID,
          ),
        ),
      },
    ],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return <MedicareTmsCoverage />;
}
